import s from "./news.module.css";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import {useSelector} from "react-redux";
import {ReactComponent as LikeSocial} from "../../img/categories/assets/likesocial.svg";
import {ReactComponent as Twitter} from "../../img/categories/assets/twitter.svg";
import React, {useState} from "react";

const SingleNew = () => {
    const singleNew = useSelector(state => state.setNew);
    const [likesCount, setLikesCount] = useState(0);

    return (
        <div className={s.news}>
            <div className={`${s.newsContent} content`}>
                <Breadcrumbs title={singleNew.title}/>
                <h3>{singleNew.title}</h3>
                <div className={s.singleNewItem}>
                    <img src={singleNew.img} alt=""/>
                    <div className={s.singleNewInfo}>
                        <span>{singleNew.day}</span>
                        <p>{singleNew.post}</p>
                        <div className={s.productIcons}>
                            <div onClick={() => setLikesCount(likesCount + 1)}>
                                <LikeSocial/><span>Like <span>{likesCount}</span></span></div>
                            <div><Twitter/></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default SingleNew;